import { Fragment } from 'react';
import IconTileBreakup from '@/components/_rebrand/IconTileBreakup';

const getBackgroundColorCode = (colorSelection) => {
  switch (colorSelection) {
    case 'green':
      return 'bg-green-700';
    case 'violet':
      return 'bg-violet-900';
    case 'pink':
      return 'bg-pink-700';
    case 'lightViolet':
      return 'bg-violet-100';
    case 'blue':
      return 'bg-blue-1000';
    case 'yellow':
      return 'bg-yellow-900';
    case 'gray':
      return 'bg-gray-950';
    case 'salmon':
      return 'bg-salmon-950';
    case 'darkGreen':
      return 'bg-green-900';
    case 'darkPink':
      return 'bg-pink-900';
    default:
      return 'bg-neutral-200';
  }
};

const BlockDivider = ({ entry }) => {
  const backgroundColor = getBackgroundColorCode(entry.colorSelection);

  return (
      <div className={`hidden md:block h-30 py-0 md:h-[10vw] relative w-full overflow-hidden ${backgroundColor}`}>
          <IconTileBreakup
            data-fill-color="#FFFFFF"
            className={`absolute left-[-100vw] right-[-100vw] ${entry.flipDirection ? `top-[-2px]` : `bottom-[-2px]`} p-0 m-0 w-[300vw] md:left-0 md:right-0 md:w-full h-auto`}
            style={{ transform: entry.flipDirection ? 'rotate(180deg)' : 'none' }}
          />
      </div>
  );
};

export default BlockDivider;
